export default __webpack_public_path__ + "static/media/logo.9099b553.svg";